<script>
    import { createEventDispatcher } from 'svelte';
    import IconDel from "../icons/IconDel.svelte";
    import IconEdit from '../icons/IconEdit.svelte';

    export let cheeseType = {id: 0, name: '', description: '', maturationDays: 0, pricePerKiloGram: 0.0, weigthLosPercent: 0.0};

    const dispatch = createEventDispatcher();
    function customerDeleted() {
        dispatch('cheeseTypeDeleted', {
            
        });
    }

    function editCheeseType(editedCheeseType) {
        let editedCheeseTypeItem = editedCheeseType.detail.item;
        dispatch('editCheeseType', {
            editedCheeseTypeItem
        });
    }
</script>

<div class="box">
    <div class="icons">
        <IconEdit item={cheeseType} on:clicked={(editedCheeseType) => editCheeseType(editedCheeseType)}/>
        <!--IconDel customer={customer} on:clicked={customerDeleted}/-->
    </div>
    <div class="content">{cheeseType.name}&nbsp;{cheeseType.description}</div>
    <div class="contentDetails">{cheeseType.maturationDays}&nbsp;{cheeseType.pricePerKiloGram}&nbsp;{cheeseType.weigthLosPercent}</div>
</div>

<style>
    .content {
        margin-top: -20px;
        margin-right: 40px;
        cursor: default;
    }

    .contentDetails {
        margin-top: 0px;
        margin-right: 40px;
        cursor: default;
    }

	.box {
	  background: lightgray;
	  padding: 10px;
	  border-radius: 0.8rem;
      margin-bottom: 10px;
	  display: flex;
	  flex-direction: column;
	}
    
    .icons {
        align-self: flex-end;
        display: inline-flex;
        justify-content: space-between;
    }

</style>